import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleIndicator = ({ userRole, isVisible }) => {
  const roleConfig = {
    sales: {
      label: 'Ventas',
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary-50',
      description: 'Gestión de presupuestos y clientes'
    },
    warehouse: {
      label: 'Almacén',
      icon: 'Warehouse',
      color: 'text-accent',
      bgColor: 'bg-accent-50',
      description: 'Control de inventario y stock'
    },
    logistics: {
      label: 'Logística',
      icon: 'Truck',
      color: 'text-warning',
      bgColor: 'bg-warning-50',
      description: 'Gestión de envíos y transporte'
    },
    accounting: {
      label: 'Contabilidad',
      icon: 'Calculator',
      color: 'text-secondary',
      bgColor: 'bg-secondary-50',
      description: 'Facturación y registros financieros'
    },
    management: {
      label: 'Gerencia',
      icon: 'Crown',
      color: 'text-error',
      bgColor: 'bg-error-50',
      description: 'Supervisión y reportes'
    },
    admin: {
      label: 'Administrador',
      icon: 'Settings',
      color: 'text-text-primary',
      bgColor: 'bg-secondary-100',
      description: 'Configuración del sistema'
    }
  };

  if (!isVisible || !userRole || !roleConfig[userRole]) {
    return null;
  }

  const role = roleConfig[userRole];

  return (
    <div className={`mt-6 p-4 rounded-lg border ${role.bgColor} border-border transition-all duration-300 animate-in slide-in-from-bottom-2`}>
      <div className="flex items-center space-x-3">
        <div className={`p-2 rounded-full ${role.bgColor} ${role.color}`}>
          <Icon name={role.icon} size={20} />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-body-medium text-text-primary">
            Acceso como {role.label}
          </h3>
          <p className="text-xs text-text-secondary mt-1">
            {role.description}
          </p>
        </div>
        <div className="flex items-center">
          <Icon name="CheckCircle" size={16} className="text-success" />
        </div>
      </div>
    </div>
  );
};

export default RoleIndicator;